<router-outlet></router-outlet>
<ngx-spinner
  bdColor="#F4F4F4"
  size="medium"
  color="#113455"
  type="ball-spin-clockwise"
  [fullScreen]="true"
>
  <h4 class="loading-text">
    {{ loadingText }}
  </h4>
</ngx-spinner>
